




























































import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import { QDialog } from "quasar";
import { sendReminder } from "@/services";
import { notifyError, notifySuccess } from "@/common/notify";

@Component
export default class ReminderDialog extends Vue {
  @Ref("reminder-dialog")
  dialog!: QDialog;

  @Prop({ type: Number, required: true })
  userId!: number;

  private formData = {
    subject: "Promemoria compilazione sondaggi",
    message:
      "Gentili buongiorno,\na mezzo della presente si richiede la compilazione dei sondaggi ancora mancanti - o incompleti - sulla piattaforma realizzata per gli ambiti da Toscana Promozione. ",
  };

  success = false;
  submit = false;
  loading = false;

  async onSubmit() {
    this.submit = true;
    this.loading = true;

    try {
      console.log(this.userId);
      await sendReminder(this.userId, this.formData);
      this.success = true;
      notifySuccess("Sollecito inviato con successo!");
      this.hide();
    } catch (error) {
      this.success = false;
      notifyError("Non è stato possibile inviare il sollecito, riprova più tardi!");
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  onCancelButton() {
    this.$emit("ok");
    this.hide();
  }

  onCancel() {
    this.$emit("cancel");
    this.hide();
  }

  show() {
    this.dialog.show();
  }

  hide() {
    this.dialog.hide();
  }

  onCancelClick() {
    this.hide();
  }

  onDismissClick() {
    this.hide();
  }

  onDialogHide() {
    this.$emit("hide");
  }
}
